import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILoggedInUser } from 'src/app/models/User';

interface UserState {
    loggedinUser: ILoggedInUser;
}

const initialState: UserState = {
    loggedinUser: {
        airportPermissions: [],
    } as ILoggedInUser,
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setLoggedinUser: (state, action: PayloadAction<ILoggedInUser>) => {
            state.loggedinUser = action.payload;
        },
    },
});

export const { setLoggedinUser } = userSlice.actions;
export default userSlice.reducer;
